import BinIcon from '../../../../components/icon/IconWrapped';
import { TutorialPlayIconStyled } from './styled/TutorialPlayIconStyled';
import classNames from 'classnames';

interface ITutorialPlayIconProps {
    isSeen?: boolean,
    size?: 'sm' | 'lg',
}

function TutorialPlayIcon(props: ITutorialPlayIconProps) {
    const { isSeen, size } = props;

    return <TutorialPlayIconStyled
        className={classNames({
            'is-seen': isSeen,
            lg: size === 'lg',
        })}
    >
        <BinIcon
            name={isSeen ? 'IcCheckMark' : 'IcPlayRound'}
            size={size === 'lg' ? 36 : 28}
        />
    </TutorialPlayIconStyled>
}

export default TutorialPlayIcon;
